import { useNavigate } from "react-router-dom";
import DynamicFormPage from "../../components/DynamicFormPage";
import { createPaymentMethod } from "../../helpers/http_payment_methods_requests";

export default function OrderPaymentMethodsNew() {

    const navigate = useNavigate();

    const formFieldList = [
        {
            title: "Formas de Pagamento",
            fields: [
                {
                    name: "name",
                    label: "Nome",
                    type: "text",
                    required: true,
                },
                {
                    name: "description",
                    label: "Descrição",
                    type: "text",
                    multiline: true,
                    rows: 5,
                    fullWidth: true,
                    required: true,
                },
            ]
        },
    ];

    const handleSubmit = (data) => {
        createPaymentMethod(data, () => navigate('/formas-de-pagamento'))
    };

    return <DynamicFormPage title={"Formas de Pagamento - Cadastro"} onSubmit={handleSubmit} formFieldList={formFieldList} onCancel={() => navigate(-1)} />;

};
